import React, { useContext, useState } from "react";
import ReactModal from "react-modal";
import { Context } from "../context/MainContext";
import { Link, useNavigate } from "react-router-dom";
import { userLogOut } from "../context/Action";

const UserModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { user, dispatch } = useContext(Context);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("sokoUser");
    dispatch(userLogOut());
    navigate("/login");
  };
  return (
    <div>
      <ReactModal
        className="modalMain"
        overlayClassName="modal-overlayUser"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Cart Modal"
      >
        <div className="topbar__modal">
          {/* <div className="topbar__modal__img">
            <img src={user?.image ? user?.image : profile} alt="" />
          </div> */}

          {/* <h3>
            {user?.firstName} {user?.lastName}
          </h3> */}
          {/* <p>{user?.email}</p> */}

          <ul
            className="topbar__modal__list"
            onClick={() => setModalIsOpen(false)}
          >
            <Link to="/account">
              <li>
                <i className="bx bx-user"></i> My account
              </li>
            </Link>
            <li className="last" onClick={handleLogout}>
              <i className="bx bx-arrow-out-left-square-half"></i> Logout
            </li>
          </ul>
        </div>
      </ReactModal>

      <div
        className="topbar__top__right__acc"
        onClick={() => (user?.id ? setModalIsOpen(true) : navigate("login"))}
      >
        <i class="bx bx-user-circle"></i>
        <span>
          {user?.id ? `${user?.firstName} ${user?.lastName}` : "My account"}
        </span>
      </div>
    </div>
  );
};

export default UserModal;
